import { ArticleItem } from 'data/generated/graphql';
import { useAppQuery } from 'data/query-client';
import restClient from 'data/restClient';
import { useAuthToken } from './useAuthToken';
import { useConvertedProperty } from './useConvertedProperty';

import type { Container, Metadata } from 'contexts/datamodel/DataModelContext.core';

const getAllessehDedupedQuery = (
  authToken: string,
  artifactDTO: {
    root: Container;
    metadata: Metadata;
  },
  queryId: string,
  currentProperty: string | null
) =>
  restClient.post<ArticleItem[]>('allesseh/dedupedQuery', artifactDTO, {
    headers: {
      Authorization: authToken
    },
    params: {
      queryId,
      publicationKey: currentProperty
    }
  });

export const useAllessehDedupedQuery = (
  artifactDTO: {
    root: Container;
    metadata: Metadata;
  },
  queryId: string,
  options?: { enabled: boolean }
) => {
  const authToken = useAuthToken();
  const currentProperty = useConvertedProperty();

  return useAppQuery(
    [artifactDTO, queryId],
    () => getAllessehDedupedQuery(authToken, artifactDTO, queryId, currentProperty),
    {
      ...options,
      staleTime: 0,
      cacheTime: 0
    }
  );
};
